import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  /* background-color: var(--color-white); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  height: calc(100vh - 22vh);
  height: calc(100dvh - 22dvh);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
  @media (max-width: 900px) {
    height: calc(100vh - 20vh);
    height: calc(100dvh - 20dvh);
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding: 10px 0 20px 0px;
  h1 {
    text-align: center;
  }
  z-index: 1;
  margin-top: 10px;
  /* Ocultar barra de scroll pero permitir desplazamiento */
  -ms-overflow-style: none; /* IE y Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari y Opera */
  }

  /* Tablet: 2 columnas centradas */
  @media (min-width: 768px) and (max-width: 1199px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
    align-content: flex-start;
    padding: 20px 20px 20px 20px;
    box-sizing: border-box;
    max-width: calc(666px + 24px + 40px); /* 2*333 + gap + 2*20 */
    margin: 30px auto 0 auto;
  }

  /* Desktop: 3 columnas centradas */
  @media (min-width: 1200px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 28px;
    justify-content: center;
    align-content: flex-start;
    padding: 30px 40px 30px 40px;
    box-sizing: border-box;
    max-width: calc(999px + 56px + 80px); /* 3*333 + 2*gaps + 2*40 */
    margin: 30px auto 0 auto;
  }
`;

export const ButtonP5 = styled.button`
  width: 212px;
  height: 39px;
  padding: 8px;
  background: var(--color-primary);
  font-size: 18px;
  color: var(--color-white);
  border-radius: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  ${({ latex10 }) =>
    latex10 === 1 ? " background: var(--color-latex10);" : ""}
`;

export const ContainerButton = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 15px 0 25px 0;
  background-color: var(--color-white);
  z-index: 2;

  @media (min-width: 768px) {
    padding: 10px 0 10px 0;
  }
`;

export const ContainerSinTurno = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 35px;
  margin-top: 81px;
  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
  .subtitle {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
`;
